import { useFormState } from 'react-use-form-state';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from '@apollo/react-hooks';

import { UPDATE_CUSTOMER } from './queries';

const _v = {
  oldPassword: 'oldPassword',
  newPassword: 'newPassword',
  confirmPassword: 'confirmPassword',
};

const useUpdateCustomerPassword = ({ customer } = {}) => {
  if (!customer) throw new Error('No customer supplied to provider');

  const [formState, form] = useFormState({
    [_v.oldPassword]: '',
    [_v.newPassword]: '',
    [_v.confirmPassword]: '',
  });
  const { addToast } = useToasts();

  const [runMutation, { loading }] = useMutation(UPDATE_CUSTOMER, {
    onCompleted: () => {
      addToast('Your Password has Been updated', {
        appearance: 'success',
        autoDismiss: true,
        autoDismissTimeout: 8000,
      });
    },
    onError: (err) => {
      console.log(err);
      if (err.graphQLErrors) {
        err.graphQLErrors.forEach((e) => {
          if (e.message.includes('E11000 duplicate key error collection: browncon.customers index: email_1 dup key:')) {
            addToast(
              "Seems you are already registered with us. Can't wait to work with you, We'll get back to you shortly",
              {
                appearance: 'success',
                autoDismiss: true,
                autoDismissTimeout: 10000,
              },
            );
          } else {
            addToast(e.message, {
              appearance: 'error',
              autoDismiss: true,
            });
          }
        });
      } else {
        addToast('Something unexpected happened', {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    // TODO: validation

    // TODO: mutation
    console.log(formState.values);
    runMutation({ variables: { id: customer.id, data: {} } });
  };

  return {
    _v,
    form,
    formState,
    handleSubmit,
    loading,
  };
};

export default useUpdateCustomerPassword;
